'use client';

import {
	MediaLibraryIcon,
	Css,
	Responsive,
	InfoMediaResourcesIcon,
	MediaContactIcon,
} from '@/ui';
import styled from '@emotion/styled';
import { RouterLink } from '../../../components/common/link/RouterLink';
import { Color } from '../../../styles/Color';
import { Shadow } from '../../../styles/Shadow';
import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';

const mediaEntryPoints = [
	{ href: PageRoutes.MediaResources, icon: 'info', label: 'Media Resources' },
	{
		href: PageRoutes.MediaLibrary,
		icon: 'media-library',
		label: 'Media Library',
	},
	{
		href: PageRoutes.MediaContacts,
		icon: 'media-contacts',
		label: 'Media Contacts',
	},
];

function getLinkButtonIcon(icon: string) {
	switch (icon) {
		case 'info':
			return <InfoMediaResourcesIcon aria-hidden />;
		case 'media-library':
			return <MediaLibraryIcon aria-hidden />;
		case 'media-contacts':
			return <MediaContactIcon aria-hidden />;
		default:
			return <span>Icon not found!</span>;
	}
}

export default function NewsroomEntryPoints() {
	return (
		<EntryPointsWrapper>
			{mediaEntryPoints.map((link) => (
				<EntryPoint key={link.label} href={link.href} aria-label={link.label}>
					<EntryPointsIconWrapper>
						{getLinkButtonIcon(link.icon)}
					</EntryPointsIconWrapper>
					{link.label}
				</EntryPoint>
			))}
		</EntryPointsWrapper>
	);
}

export const EntryPointsIconWrapper = styled.div<{ oxdThemed?: boolean }>`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	color: ${({ oxdThemed }) =>
		oxdThemed ? `${Color.OxdPrimary}` : `${Color.PrimaryBlue}`};

	background: ${({ oxdThemed }) =>
		oxdThemed ? `${Color.OxdBackground}` : `${Color.PrimaryBlue97}`};
	border-radius: ${Css.pxToRem(8)};
	padding: ${Css.pxToRem(10)};
	width: ${Css.pxToRem(52)};
	height: ${Css.pxToRem(52)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: 40px;
		height: 40px;
		padding: ${Css.pxToRem(6)};
	}

	svg {
		path {
			fill: currentColor;
		}
	}
`;

export const EntryPointsWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	max-width: 1200px;
	margin: 0 auto;

	gap: ${Css.pxToRem(24)};
	margin-top: ${Css.pxToRem(-45)};
	margin-bottom: ${Css.pxToRem(45)};

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
		padding: 0 24px;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-template-columns: repeat(1, minmax(0, 1fr));
		padding: 0 12px;
		margin-top: ${Css.pxToRem(-32)};
		gap: ${Css.pxToRem(8)};
	}
`;

export const EntryPoint = styled(RouterLink)`
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-grow: 1;
	max-width: ${Css.pxToRem(390)};
	height: ${Css.pxToRem(84)};
	border-radius: 16px;
	padding: ${Css.pxToRem(16)};
	background: ${Color.OnPrimarySurface};
	box-shadow: ${Shadow.Large};
	gap: ${Css.pxToRem(24)};
	text-decoration: none;
	font-weight: 700;
	color: ${Color.OnBackgroundText};
	font-size: ${Css.pxToRem(22)};
	line-height: ${Css.pxToRem(30)};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		font-size: ${Css.pxToRem(20)};
		gap: ${Css.pxToRem(16)};
	}
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: 100%;
		height: ${Css.pxToRem(64)};
		width: 100%;
		font-size: ${Css.pxToRem(20)};
	}
`;
